var _circle, _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpgradeAccountIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 197,
    viewBox: "0 0 212 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 113.091,
    cy: 97.042,
    r: 97.042,
    fill: "#ECEEF5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mckw48uuza",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 212,
    height: 193
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M206.775 116.078c-6.87 24.586-16.892 41.467-38.549 57.089a13.63 13.63 0 0 1-4.671 2.144l-81.872 20.468c-1.446.361-2.94.495-4.428.395l-52.839-3.544a14.314 14.314 0 0 1-10.05-5.135l-10.75-12.944A14.311 14.311 0 0 1 .34 164.549L9.15 18.044C9.65 9.72 17.13 3.587 25.39 4.727l93.371 12.89a14.31 14.31 0 0 0 4.328-.064l71.213-11.966c9.062-1.523 17.2 5.76 16.762 14.938-1.926 40.377-3.456 92.571-4.289 95.553z",
    fill: "#ECEEF5"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mckw48uuza)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 128.716,
    cy: 107.417,
    r: 59.058,
    fill: "#ECEEF5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.885,
    y: 65.148,
    width: 176.629,
    height: 122.45,
    rx: 3.25,
    transform: "rotate(-11.516 21.885 65.148)",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.934,
    y: 94.211,
    width: 41.639,
    height: 25.773,
    rx: 1.5,
    fill: "#EAEDF3",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.842 140.187c-7.699-5.28-23.698-18.746-30.736-24.82a4.793 4.793 0 0 1 0-7.03c3.16-3.156 6.176-1.291 7.756 0l16.941 13.486c.98-1.262 2.439-1.935 3.31-2.152 3.782.096 12.581 0 17.522-1.148 6.176-1.434 9.192-3.156 15.655-1.578 5.17 1.263 10.867 5.5 13.07 7.461 1.71-2.64 3.393-2.631 4.021-2.296 1.484.956 4.711 3.099 5.745 4.017 1.034.918.718 2.582.431 3.3-3.399 5.452-10.427 16.671-11.346 17.933-.92 1.263-2.777.909-3.591.574-1.484-.956-4.711-3.07-5.745-3.874-1.034-.803-.814-2.056-.574-2.582-.24-.813-2.011-2.439-7.182-2.439-3.734.287-15.655 7.747-25.277 1.148z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.301 141.478c-.24-.813-2.011-2.439-7.182-2.439-3.734.287-15.655 7.747-25.277 1.148-7.699-5.28-23.698-18.746-30.736-24.82a4.793 4.793 0 0 1 0-7.03c3.16-3.156 6.176-1.291 7.756 0l16.941 13.486m38.498 19.655 11.059-17.072m-11.059 17.072c-.24.526-.46 1.779.574 2.582 1.034.804 4.261 2.918 5.745 3.874.814.335 2.671.689 3.591-.574.919-1.262 7.947-12.481 11.346-17.933.287-.718.603-2.382-.431-3.3-1.034-.918-4.261-3.061-5.745-4.017-.628-.335-2.311-.344-4.021 2.296m0 0c-2.203-1.961-7.9-6.198-13.07-7.461-6.463-1.578-9.479.144-15.655 1.578-4.941 1.148-13.74 1.244-17.522 1.148-.871.217-2.33.89-3.31 2.152m26.577 6.886h-23.267c-1.532-.191-4.539-1.319-4.309-4.303a4.745 4.745 0 0 1 .999-2.583",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.951,
    y: 83.305,
    width: 45.605,
    height: 10.899,
    rx: 1.5,
    fill: "#EAEDF3",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m120.823 99.238-.349-.342-.35.342-6.315 6.177v-22.11h12.882v21.672l-5.868-5.74z",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 82.569,
    cy: 168.082,
    r: 25.282,
    fill: "#fff",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.492 152-13.494 9.227V181h26v-19.773L83.492 152z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.079 86.77c0 10.688-8.445 19.332-18.836 19.332-10.392 0-18.837-8.644-18.837-19.332 0-10.69 8.445-19.332 18.837-19.332 10.391 0 18.836 8.643 18.836 19.332z",
    fill: "#fff",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.34 76-9.342 6.046V95h18V82.046L180.34 76z",
    fill: "#66BB6A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 96.451,
    cy: 49.09,
    r: 13.383,
    fill: "#fff",
    stroke: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#000",
    d: "m97.922 147.574 8.017-13.463M101.936 61.374l9.846 22.22M140.915 104.145l22.974-7.737"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m96.707 42-5.709 3.818V54h11v-8.182L96.707 42z",
    fill: "#66BB6A"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeAccountIcon);
export default __webpack_public_path__ + "static/media/UpgradeAccountIcon.1c144321.svg";
export { ForwardRef as ReactComponent };